export const visibleColumnData = {
  firstName: true,
  lastName: true,
  // middleName: false,
  applicationStart_Display: true,
  fieldOfInterest_Display: true,
  mobile: true,
  email: true,
  createdOn: true,
  statusText: true,
  nationality_Display: false,
  createdOnDisplay: true,
  userAssigned: true,
  sourceOfConnection: false,
  // selectedTerm_Display: false,
  // grade_Display: false,
  highSchoolGPA: false,
  curriculum_Display: false,
  lastEmailReceivedOnDisplay: false,
};
